import app from 'flarum/forum/app';

/** Открыть редактор новой темы сразу в нужном разделе. Гостю — окно входа. */
export default function startDiscussion(tags = []) {
  if (!app.session.user) {
    app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal'));
    return Promise.resolve(false);
  }
  return app.composer.load(() => flarum.reg.asyncModuleImport('flarum/forum/components/DiscussionComposer'), {
    user: app.session.user
  }).then(() => {
    app.composer.fields.tags = tags.slice(0);
    app.composer.show();
    m.redraw();
    return true;
  });
}